import { Typography, LinearProgress, Box } from '@mui/material';
import styles from "./HealthScoreBar.module.scss";

export interface HealthScoreBarProps {
   score: number;
   childType?: string;
}

export default function HealthScoreBar (props: HealthScoreBarProps) {
   const { score, childType = "Sessions" } = props;
   const colors = {
      success: "#2e7d32",
      warning : "#ed6c02",
      error: "#d32f2f"
   }

   const barColorCalc = (score: number | undefined) => {
      if (typeof score === 'undefined' || score < 25) {
         return colors.error
      } else if (score >= 25 && score < 50) {
         return colors.warning
      } else {
         return colors.success
      }
   }

   return (
      <>
         { score == -1 ? (
            <Box className={styles.HealthScoreBar} sx={{opacity: 0.5}} data-value="no-sessions" >
               <Typography 
                  className={styles.text} 
                  variant="caption"
               > 
                  No {`${childType.charAt(0).toUpperCase()}${childType.slice(1)}`}
               </Typography>
            </Box>
         ) : (
            <Box 
               className={styles.HealthScoreBar} 
               sx={{color: barColorCalc(score) }} 
               data-value={typeof score == "undefined" ? "no-score" : "valid-score"} 
            >
               { typeof score == "undefined" ? (
                  <LinearProgress 
                     variant="indeterminate"
                     sx={{ mt: "3px", width: "100%", opacity: 0.5 }} 
                     color="inherit" 
                  />
               ) : (
                  <>
                     <Typography 
                        className={styles.text} 
                        variant="body1"
                        sx={{color: "inherit"}} 
                     > 
                        {score} / 100 
                     </Typography>
                     <LinearProgress 
                        variant="determinate"
                        sx={{ mt: "3px", width: "100%" }} 
                        color="inherit" 
                        value={score} 
                     />
                  </>
               )}
            </Box>
         )}
      </>
   );
}
